import { Button, Tooltip } from '@mm/components';
import { useViewActions } from '@mm/state/actions/viewActions';
import { useModalActions } from '@mm/state/modules/modalsState/actions';
import React from 'react';
import styles from './LeadsContactsToolbarButtons.module.css';
import { useImportContactsPermission } from '../../../../../common/hooks/use-import-contacts-permission';
import { EnrichButton } from '../Contacts/EnrichButton/EnrichButton';

interface P {
  processClick?: (callbackFb: (args?: any) => void) => void;
}

export const LeadsContactsToolbarButtons = (props: P) => {
  const { processClick = () => {} } = props;

  const uploadContactsPermission = useImportContactsPermission();
  const { openImportContactListModal } = useModalActions();
  const { showSlideoutMenu } = useViewActions();

  const onImportClick = () => openImportContactListModal();

  return (
    <>
      <EnrichButton />

      <Tooltip
        position="top"
        color="dark"
        useHover
        noDelayClose
        toolTipDisabled={uploadContactsPermission.isAllowed}
        anchorElement={
          <Button
            css={{ container: styles.button }}
            disabled={!uploadContactsPermission.isAllowed}
            color="secondary"
            onClick={() => processClick(() => onImportClick())}
          >
            Import
          </Button>
        }
      >
        <div className={styles.tipBody}>
          {!uploadContactsPermission.isAllowed &&
            'Connect an Email Account or activate a phone number first'}
        </div>
      </Tooltip>

      <Button
        color="secondary"
        onClick={() => showSlideoutMenu('attributesAndTags')}
        css={{ container: styles.button }}
      >
        Attributes and Tags
      </Button>
    </>
  );
};
